import React from 'react';
import { useLocation } from 'react-router-dom';
import { getOrgTermsContent } from '../../../../content/utils.js';
import ProjectsTabs from '../../../projects/ProjectsTabs.jsx';
import BreadCrumbs from '../../../BreadCrumbs.jsx';
import ProjectBreadcrumbIcon from '../../../icons/ProjectBreadcrumbIcon.jsx';
import PageHeader from '../../PageHeader.js';
import { getProjectsFilter } from '../../../../helpers/breadcrumbRouteHelpers.js';
import { ProjectsLink } from '../../../links/index.jsx';

const ProjectsHeader = () => {
  const location = useLocation();
  const projectsFilter = getProjectsFilter(location.pathname);

  return (
    <PageHeader flexJustify navigation={<ProjectsTabs />}>
      <BreadCrumbs icon={<ProjectBreadcrumbIcon />}>
        <ProjectsLink>{getOrgTermsContent('projects')}</ProjectsLink>

        {projectsFilter === 'archived' && <span>Archived</span>}
      </BreadCrumbs>
    </PageHeader>
  );
};

export default ProjectsHeader;
